import { useMemo } from "react";
import {
	DEFAULT_PUBLIC_LEGAL_FOOTER_DOCUMENTS_PREFIX,
	type PublicLegalFooterDocumentPdfPaths,
	PUBLIC_LEGAL_FOOTER_DOCUMENT_PDF_PATHS,
	PUBLIC_USER_GUIDE_ENTRY_PATH,
} from "le-coffre-resources/dist/publicLegalStaticPaths";
import { usePublicSiteConfigContext } from "@Front/Services/PublicSiteConfig/usePublicUiOptions";

export type PublicLegalStaticResolved = {
	footerDocumentsPrefix: string;
	documentPdfPaths: PublicLegalFooterDocumentPdfPaths;
	userGuideEntryPath: string;
};

function defaultPublicLegalStaticResolved(): PublicLegalStaticResolved {
	return {
		footerDocumentsPrefix: DEFAULT_PUBLIC_LEGAL_FOOTER_DOCUMENTS_PREFIX,
		documentPdfPaths: PUBLIC_LEGAL_FOOTER_DOCUMENT_PDF_PATHS,
		userGuideEntryPath: PUBLIC_USER_GUIDE_ENTRY_PATH,
	};
}

/**
 * Chemins PDF footer + guide : défauts **`le-coffre-resources`** puis valeurs **`GET /v1/public/site-config`**
 * (`public_legal_static`) via {@link PublicSiteConfigProvider}.
 */
export function usePublicLegalStaticFromSiteConfig(): PublicLegalStaticResolved {
	const { config } = usePublicSiteConfigContext();

	return useMemo(() => {
		if (!config) {
			return defaultPublicLegalStaticResolved();
		}
		const pl = config.public_legal_static;
		return {
			footerDocumentsPrefix: pl.footer_documents_prefix,
			documentPdfPaths: pl.document_pdf_paths,
			userGuideEntryPath: pl.user_guide_entry_path,
		};
	}, [config]);
}
